import React, { useRef } from "react";

const AddRoutineForm = ({ onSubmit, onCancel }) => {
	const commentRef = useRef();
	const dateRef = useRef();
	const resultRef = useRef();

	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
				onSubmit({
					comment: commentRef.current.value,
					result: resultRef.current.value,
					date: dateRef.current.value
				});
			}}
		>
			<div className="form-group m-t-20 m-b-20">
				<label htmlFor="date-id">Date & Time*</label>
				<input
					name="date-id"
					id="date-id"
					ref={dateRef}
					className="form-control"
					type="datetime-local"
				/>
			</div>
			<div className="form-group m-t-20 m-b-20">
				<label htmlFor="result-id">Result*</label>
				<input
					name="result-id"
					id="result-id"
					ref={resultRef}
					className="form-control"
					type="text"
				/>
			</div>
			<div className="form-group m-t-20 m-b-20">
				<label htmlFor="comment-id">Comments</label>
				<textarea
					name="comment-id"
					id="comment-id"
					ref={commentRef}
					className="form-control form-control-textarea"
					rows="6"
					placeholder="enter comments"
				></textarea>
			</div>

			<div className="form-group text-center m-t-20">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
				>
					Add Routine
					<i className="material-icons">keyboard_arrow_down</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
				>
					Cancel <i className="material-icons text-danger">close</i>
				</button>
			</div>
		</form>
	);
};
export default AddRoutineForm;
